import { pageAssetsView, pageAssetsHistoryView } from './api';
import { useSelector } from 'react-redux';
import Navbar from '../../components/Navbar';
import { columns } from './utils';
import { Button, Form, Row, Col, Modal } from 'react-bootstrap';
import React, { Fragment } from 'react';
import { Loader } from '../../components/Loader';
import { Grid, useGridMemory } from 'jrgrid';

class FilterButtons {
  title = '';
  variant = '';
  filter = '';

  constructor(title: any, variant: any, filter: any) {
    this.title = title;
    this.variant = variant;
    this.filter = filter;
  }
}

const buttons = [
  new FilterButtons('Need Scan', 'info', {
    id: 'needScan',
    type: 'string',
    operand: 'and',
    isLike: false,
    value: '1',
  }),
  new FilterButtons('Scanned', 'info', {
    id: 'needScan',
    type: 'string',
    operand: 'and',
    isLike: false,
    value: '0',
  }),
  new FilterButtons('New', 'info', {
    id: 'isNewItem',
    type: 'string',
    operand: 'and',
    isLike: false,
    value: '1',
  }),
  new FilterButtons('Found', 'info', {
    id: 'lostItemFound',
    type: 'string',
    operand: 'and',
    isLike: false,
    value: '1',
  }),
  new FilterButtons('Out of Department', 'info', {
    id: 'scannedOutsideDept',
    type: 'string',
    operand: 'and',
    isLike: false,
    value: '1',
  }),

  new FilterButtons('Clear', 'primary', {
    id: 'assetTableEntry',
    type: 'string',
    operand: 'and',
    isLike: false,
    value: '1',
  }),
];

export const InventoryPage = (props: any) => {
  const [gridFilter, setGridFilter] = React.useState<any>(null);
  const [inventoryYear, setInventoryYear] = React.useState<string>(String(new Date().getFullYear()));
  const [refresh, setRefresh] = React.useState<boolean>(false);
  const [gridLoading, setGridLoading] = React.useState<boolean>(true);
  const [imageModal, setImageModal] = React.useState<boolean>(false);

  const gridMemory = useGridMemory();
  const { user } = useSelector((state: any) => ({ user: state.user }));

  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const status = urlParams.get('status');

  }, []);

  const getInventoryYears = (startYear: number) => {
    var inventoryYears = [];
    var year = startYear; // First year we have inventory data
    var currentYear = new Date().getFullYear();

    while (year <= currentYear) {
      inventoryYears.push(String(year));
      year += 1;
    }
    // inventoryYears.push('All');
    return inventoryYears;
  };

  // gridMemory.setMemory({"test": "append"})
  //alert(JSON.stringify(gridMemory))

  const renderGrid = () => {
    if (refresh) {
      setTimeout(() => setRefresh(false), 500);
      return <Loader title='Reloading Grid..' />;
    } else {
      let filter = [];

      if (inventoryYear !== 'All') {
        filter.push({
          id: 'Year',
          type: 'string',
          operand: 'and',
          isLike: false,
          value: inventoryYear,
        });
      }

      const userCurrentRole = user.currentRole;
      filter.push({
        id: 'source',
        type: 'string',
        operand: 'and',
        isLike: false,
        value: userCurrentRole.source,
      });

      if (!userCurrentRole.isAdmin) {
        filter.push({
          id: 'DepartmentID',
          type: 'string',
          operand: 'and',
          isLike: false,
          value: user.currentRole.departmentId.toString(),
        });
      }

      const GridLoader = (loadingProps) => {
        if (loadingProps.loading) {
          return (
            <div style={{ position: 'absolute', alignSelf: 'center', marginTop: '10%' }}>
              <Loader />
            </div>
          );
        } else {
          setGridLoading(false);
          return null;
        }
      };

      const year = String(new Date().getFullYear());
      const query = inventoryYear === year ? pageAssetsView : pageAssetsHistoryView;
      const queryName = inventoryYear === year ? 'pageAssetsView' : 'pageAssetsHistoryView';

      return (
        <div>
          {/* <Snackbar message='Verification item updated!' visible={showUpdatedMessage} setVisible={setShowUpdatedMessage} autoDisappear />
          {console.log('filter ' + JSON.stringify(filter))} */}
          {gridLoading && <Loader title='Loading Inventory Grid...' />}
          {/* {<Loader title='Loading Inventory Grid...' />} */}
          <Grid
            LoadingComponent={GridLoader}
            amount={10}
            columns={columns}
            query={query}
            queryName={queryName}
            defaultSortField='AssetID'
            csv={user.currentRole.isAdmin}
            globalFilters={gridFilter ? [gridFilter, ...filter] : [...filter]}
            gridMemory={gridMemory}
            refresh
          />
          {/* {alert(JSON.stringify(gridMemory))}
          {gridMemory.setMemory('test')} */}
        </div>
      );
    }
  };

  var inventoryYears = getInventoryYears(2018);

  return (
    <Fragment>
      <Navbar />
      <div className='container-fluid'>
        <Row>
          <Col md={9}>
            {buttons.map((item, index) => {
              return (
                <Button
                  key={index}
                  className='mt-3 mb-3 ml-2'
                  onClick={() => {
                    setGridFilter(item.filter);
                  }}
                  // variant={filterIndex === index ? item.variant : `outline-${item.variant}`}
                >
                  {item.title}
                </Button>
              );
            })}
          </Col>
          <Col md={3}>
            <Form inline className='mt-3 mb-3 ml-2'>
              <Form.Group>
                <Form.Label className='mr-lg-1'>Viewing inventory for year: </Form.Label>
                <Form.Control
                  as='select'
                  name='inventoryYear'
                  onChange={(e: any) => {
                    setInventoryYear(e.target.value);
                    if (
                      (inventoryYear === inventoryYears[inventoryYears.length - 1] && e.target.value !== inventoryYears[inventoryYears.length - 1]) ||
                      (inventoryYear !== inventoryYears[inventoryYears.length - 1] && e.target.value === inventoryYears[inventoryYears.length - 1])
                    ) {
                      setGridLoading(true);
                    }
                  }}
                  defaultValue={inventoryYear}>
                  {inventoryYears.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Form>
          </Col>
        </Row>
        <div>{renderGrid()}</div>
      </div>
    </Fragment>
  );
};
